/**
 * @file        src/components/BrandingHead.jsx
 * @description Applies the tenant's branding to the browser chrome: document
 *              title and tab favicon / apple-touch icon. index.html ships a
 *              neutral title and the bundled default icon; this swaps them the
 *              moment the tenant's configured branding (useBranding →
 *              /site-settings/public, resolved per Host) arrives. Renders
 *              nothing. Without this, every tenant's admin tab showed the
 *              hardcoded NeonHolidays icon + title.
 * @author      Kinetika Labs
 * @created     2026-08-04
 * @changelog
 *   - 2026-08-04 Claude — Initial.
 */
import { useEffect } from 'react';
import { useBranding } from '../lib/useBranding';

export default function BrandingHead() {
  const { markUrl, name } = useBranding();

  useEffect(() => {
    if (name) document.title = `${name} · Admin Console`;
  }, [name]);

  useEffect(() => {
    if (!markUrl) return; // keep the bundled default icon
    for (const rel of ['icon', 'apple-touch-icon']) {
      let link = document.querySelector(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement('link');
        link.rel = rel;
        document.head.appendChild(link);
      }
      // The static tag says type="image/png"; the configured mark may be webp,
      // so drop the hint and let the browser sniff.
      link.removeAttribute('type');
      link.href = markUrl;
    }
  }, [markUrl]);

  return null;
}
